import { MenuT } from 'types/frontend/Menu';

const t = (str: string) => str;
const textbookMenuRootPath = '/teacherSide/textbook';

const textbookMenu: MenuT = [
  {
    title: t('교재 관리'),
    items: [
      {
        title: t('교재 목록'),
        path: `${textbookMenuRootPath}/list`,
        accessablePositions: ['director', 'assistantDirector'],
      },
    ],
  },
  {
    title: t('교재 지급'),
    items: [
      {
        title: t('교재 지급하기'),
        path: `${textbookMenuRootPath}/dist/add`,
        accessablePositions: ['director', 'assistantDirector'],
      },
      {
        title: t('지급된 교재 리스트'),
        path: `${textbookMenuRootPath}/dist/list`,
        accessablePositions: ['director', 'assistantDirector'],
      },
    ],
  },
];

export { textbookMenu };
